import { Badge, SpaceBetween } from '@amzn/awsui-components-core';
import { ContentWorkflow, WorkflowTag } from '@amzn/awscat-pattern-library-service-model';
import React from 'react';
import { workflowTagDisplayName } from '../utils/DisplayNames';
import { getContentWorkflowTags } from '../utils/WorkflowTagUtils';

interface Props {
  workflow: ContentWorkflow;
}

const displayConfig = new Map<
  WorkflowTag,
  { color: 'blue' | 'grey' | 'green' | 'red'; displayName: string }
  // @ts-expect-error TS2769 - strict migration
>([
  [
    WorkflowTag.INFRINGED,
    { color: 'red', displayName: workflowTagDisplayName.get(WorkflowTag.INFRINGED) },
  ],
  [
    WorkflowTag.MOVED_TO_SUGGESTIONS,
    { color: 'blue', displayName: workflowTagDisplayName.get(WorkflowTag.MOVED_TO_SUGGESTIONS) },
  ],
  [
    WorkflowTag.NEEDS_IAM_REVIEW,
    { color: 'blue', displayName: workflowTagDisplayName.get(WorkflowTag.NEEDS_IAM_REVIEW) },
  ],
  [WorkflowTag.TEST, { color: 'grey', displayName: workflowTagDisplayName.get(WorkflowTag.TEST) }],
  [
    WorkflowTag.UPDATE_IN_PROGRESS,
    { color: 'green', displayName: workflowTagDisplayName.get(WorkflowTag.UPDATE_IN_PROGRESS) },
  ],
  [
    WorkflowTag.WAITING_FOR_UPDATE,
    { color: 'blue', displayName: workflowTagDisplayName.get(WorkflowTag.WAITING_FOR_UPDATE) },
  ],
  [
    WorkflowTag.CUSTOM_XML,
    { color: 'blue', displayName: workflowTagDisplayName.get(WorkflowTag.CUSTOM_XML) },
  ],
  [
    WorkflowTag.EKS_PILOT,
    { color: 'blue', displayName: workflowTagDisplayName.get(WorkflowTag.EKS_PILOT) },
  ],
  [
    WorkflowTag.SOLUTIONS_PILOT,
    { color: 'blue', displayName: workflowTagDisplayName.get(WorkflowTag.SOLUTIONS_PILOT) },
  ],
  [
    WorkflowTag.AUTOMATED_PREAPPROVAL,
    { color: 'blue', displayName: workflowTagDisplayName.get(WorkflowTag.AUTOMATED_PREAPPROVAL) },
  ],
]);

const WorkflowTagBadges = ({ workflow }: Props) => {
  const tags = getContentWorkflowTags(workflow);

  if (!tags || tags.size === 0) {
    return null;
  }
  const tagBadges = Array.from(tags).map((tag) => {
    const badgeConfig = displayConfig.get(tag) || { color: 'grey', displayName: tag };
    return (
      <Badge key={tag} color={badgeConfig.color}>
        {badgeConfig.displayName}
      </Badge>
    );
  });

  return (
    <SpaceBetween direction="vertical" size="xxxs">
      {tagBadges}
    </SpaceBetween>
  );
};

export default WorkflowTagBadges;
